import { Button, Card, Form, Input, Select } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { formItemLayoutLeft, inputLayoutLeft } from "../../constants/ApplicationConstants/FormConstants";
import FormInputRules from "../../util/FormInputRules";
import { General } from "../../util/General";
import { RouteConstants } from "../../constants/ApplicationConstants/RouteConstants";

const { Option } = Select;

const EmergencyRetrivalRequest = () => {
  const navigate = useNavigate();
  const [keyFOB, setKeyFOB] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const handleBack = () => {
    navigate(-1);
  };
  const handleSubmit = () => {
    navigate(`${RouteConstants.DEFAULT_HOME_PAGE}`);
  };

  const handleVerifyKeyFOB = () => {
    if (keyFOB === "5") {
      setIsSubmitDisabled(false);
      setErrorMessage("");
    } else {
      setIsSubmitDisabled(true);
      setErrorMessage("Invalid key FOB. Please enter validate key FOB.");
    }
  };
  return (
    <Card className="gx-card card--height" title="Emergency Retrival Request">
      <Form {...formItemLayoutLeft}>
        <Form.Item {...inputLayoutLeft} name="key_fob" label="Enter key FOB" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("key FOB")]}>
          <div className="display-flex">
            <Input name="key_fob" value={keyFOB} onChange={(e) => setKeyFOB(e.target.value)} />
            <Button className="gx-mb-0 button-gradiant ml10" onClick={handleVerifyKeyFOB}>
              Verify KeyFOB
            </Button>
          </div>
          {errorMessage && <div className="color-red">{errorMessage}</div>}
        </Form.Item>
        {!isSubmitDisabled && (
          <div>
            <Form.Item {...inputLayoutLeft} name="customer_id" label="Customer Name" rules={[FormInputRules.requiredFieldSelectRule("customer name")]}>
              <Select showSearch allowClear dropdownStyle={{ maxHeight: "200px", overflowY: "auto" }} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select Customer">
                <Option>Customer 1</Option>
              </Select>
            </Form.Item>
          </div>
        )}
        <Form.Item className="form-button form-button-pr ">
          <Button className="gx-mb-0 button-gradiant" onClick={handleSubmit} disabled={isSubmitDisabled}>
            Submit
          </Button>
        </Form.Item>
        <Form.Item className="form-button form-button-pr ">
          <Button className="gx-mb-0 button-gradiant" onClick={handleBack}>
            Back
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
export default EmergencyRetrivalRequest;
